var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_353_7071)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_7071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00401 26L7.35601 21.032C6.46515 19.5049 5.99711 17.768 6.00001 16C6.00001 10.477 10.477 6 16 6C21.523 6 26 10.477 26 16C26 21.523 21.523 26 16 26C14.2328 26.0029 12.4967 25.5352 10.97 24.645L6.00401 26ZM12.391 11.308C12.2619 11.316 12.1357 11.35 12.02 11.408C11.9115 11.4694 11.8125 11.5462 11.726 11.636C11.606 11.749 11.538 11.847 11.465 11.942C11.0954 12.423 10.8966 13.0134 10.9 13.62C10.902 14.11 11.03 14.587 11.23 15.033C11.639 15.935 12.312 16.89 13.201 17.775C13.415 17.988 13.624 18.202 13.849 18.401C14.9524 19.3725 16.2673 20.073 17.689 20.447L18.258 20.534C18.443 20.544 18.628 20.53 18.814 20.521C19.1053 20.506 19.3896 20.4271 19.647 20.29C19.813 20.202 19.891 20.158 20.03 20.07C20.03 20.07 20.073 20.042 20.155 19.98C20.29 19.88 20.373 19.809 20.485 19.692C20.568 19.606 20.64 19.505 20.695 19.39C20.773 19.227 20.851 18.916 20.883 18.657C20.907 18.459 20.9 18.351 20.897 18.284C20.893 18.177 20.804 18.066 20.707 18.019L20.125 17.758C20.125 17.758 19.255 17.379 18.724 17.137C18.668 17.1126 18.608 17.0987 18.547 17.096C18.4786 17.089 18.4095 17.0967 18.3443 17.1186C18.2791 17.1405 18.2193 17.1761 18.169 17.223V17.221C18.164 17.221 18.097 17.278 17.374 18.154C17.3325 18.2098 17.2754 18.2519 17.2098 18.2751C17.1443 18.2982 17.0733 18.3013 17.006 18.284C16.9409 18.2666 16.877 18.2445 16.815 18.218C16.691 18.166 16.648 18.146 16.563 18.109L16.558 18.107C15.9859 17.8572 15.4562 17.5198 14.988 17.107C14.862 16.997 14.745 16.877 14.625 16.761C14.2316 16.3842 13.8887 15.958 13.605 15.493L13.546 15.398C13.5036 15.3342 13.4694 15.2653 13.444 15.193C13.406 15.046 13.505 14.928 13.505 14.928C13.505 14.928 13.748 14.662 13.861 14.518C13.9551 14.3983 14.0429 14.2738 14.124 14.145C14.242 13.955 14.279 13.76 14.217 13.609C13.937 12.925 13.647 12.244 13.349 11.568C13.29 11.434 13.115 11.338 12.956 11.319C12.902 11.313 12.848 11.307 12.794 11.303C12.6597 11.2963 12.5251 11.2977 12.391 11.307V11.308Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_353_7071",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61FB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DC143"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_7071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandColor);
export default __webpack_public_path__ + "static/media/BrandColor.40295c036f6fad69c08c74643b26f6f3.svg";
export { ForwardRef as ReactComponent };